// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherFilledSvg from "@fishx/icons-svg/es/asn/SwitcherFilled";
import FishxIcon from '../components/FishxIcon';

var SwitcherFilled = function SwitcherFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherFilledSvg
  }));
};

SwitcherFilled.displayName = 'SwitcherFilled';
export default React.forwardRef(SwitcherFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwitcherFilled.js
// module id = 4211
// module chunks = 0